import ClickOutside from "./ClickOutside";
import VFocus from "./VFocus";
import VHover from "./VHover";
import VObserver from "./VObserver";
import VScrollRestoration from "./ScrollRestoration";
import VResize from "./Resize";
import VResizeInit from "./Resize/init";

export default [
    ClickOutside,
    VFocus,
    VHover,
    VObserver,
    VScrollRestoration,
    VResize,
    VResizeInit,
]